import { Injectable } from '@angular/core';
import { Observable, delay, of } from 'rxjs';
import { HeroPanelResponse, SiteStatsResponse } from './responses/site.responses';

// Mock data until the API exists.
@Injectable()
export class SiteService {
  getSiteStats(): Observable<SiteStatsResponse> {
    const stats: SiteStatsResponse = {
      memberCount: 48212,
      postCount: 1200000,
      onlineCount: 37
    };
    return of(stats).pipe(delay(100));
    // When API is ready:
    // return this.http.get<SiteStatsResponse>(`${environment.apiUrl}/site/stats`);
  }

  getHeroPanels(): Observable<HeroPanelResponse[]> {
    const panels: HeroPanelResponse[] = [
      { title: 'Battlefield', imageUrl: null },
      { title: 'Rocket League', imageUrl: null },
      { title: 'Halo', imageUrl: null },
      { title: 'Minecraft', imageUrl: null },
      { title: 'Hot Shots Golf', imageUrl: null },
      { title: 'F.E.A.R.', imageUrl: null }
    ];
    return of(panels).pipe(delay(100));
    // When API is ready:
    // return this.http.get<HeroPanelResponse[]>(`${environment.apiUrl}/site/hero-panels`);
  }
}
